import { Footer, LanguageSelector } from '@web_opxp/components';
import { AuthSelectors, FirebaseActions, getLegalComponent } from '@web_opxp/features';
import { ELanguage, LanguageActions, useTranslation } from '@web_opxp/language';
import { connect } from 'react-redux';
import { SUBSCRIBE_AVAILABLE_LANGUAGES } from '../../base/constants';
import ENV from '../../base/env';
import { getFooterMenu, getFooterSocialItems, getLegalLinks } from '../../base/footer';

export interface IFooterWrapperProps {
  session?: string;
  onLanguageSelect: (language: ELanguage) => void;
  onToggleCookieSettings: () => void;
}

export function FooterWrapperFC({ session, onLanguageSelect, onToggleCookieSettings }: Readonly<IFooterWrapperProps>) {
  const { language, t } = useTranslation();
  const handleLanguageSelect = (lang: string) => onLanguageSelect(lang as ELanguage);
  const langSelector = (
    <LanguageSelector
      availableLanguages={SUBSCRIBE_AVAILABLE_LANGUAGES}
      current={language}
      onSelect={handleLanguageSelect}
    />
  );
  const footerMenuItems = getFooterMenu(session);
  return (
    <Footer
      languageSelector={langSelector}
      copyrightLine={t('common.common:Footer.Copyright') + ' | ' + t('common.common:Footer.ContactLine')}
      footerMenuItems={footerMenuItems}
      socialBarItems={getFooterSocialItems(false)}
      legalLinks={getLegalLinks()}
      onToggleCookieSettings={onToggleCookieSettings}
      assetBaseUrl={ENV.AssetsBaseUrl}
      cookieLinkTitle={t('common.common:Cookies.FooterLink') ?? ''}
      getLegalComponent={getLegalComponent}
    />
  );
}

export const mapStateToProps = (state: any) => {
  const session = AuthSelectors.getToken(state);
  return {
    session,
  };
};

export const mapDispatchToProps = {
  onLanguageSelect: LanguageActions.changeLanguage,
  onToggleCookieSettings: FirebaseActions.toggleSettings,
};

const FooterWrapper = connect(null, mapDispatchToProps)(FooterWrapperFC);
export default FooterWrapper;
